//Libs
import React from 'react';
//Componentes Material
import CircularProgress from '@material-ui/core/CircularProgress';
import Typography from '@material-ui/core/Typography';
import AvatarPage from './AvatarPage';

/**
 * Renderiza uma página com o logo da empresa e um loader
 */
function LoadingAppPage() {
    return (
        <AvatarPage>
            <Typography component="h1" variant="h5">Carregando aplicação</Typography>
            <CircularProgress />
        </AvatarPage>
    );
}

export default LoadingAppPage;